import DateFormat from "../utils/DateFormat"

export const fromWorkEntryDTO = (entry) => {
    return {
        start: new Date(entry.start),
        end: new Date(entry.end),
    }
}

export const fromWorkEntriesDTO = (workEntries) => workEntries.map(we => fromWorkEntryDTO(we))

export const toWorkEntryDTO = (entry) => {
    return {
        start: entry.start.toISOString(),
        end: entry.end.toISOString(),
    }
}

export const toWorkEntriesDTO = (workEntries) => workEntries.map(we => toWorkEntryDTO(we))

export const fromWorkDayDTO = (day) => {
    return {
        id: day.id ? day.id : null,
        date:  day.date ? new Date(day.date) : day.start ? new Date(day.start) : null,
        start: day.start ? new Date(day.start) : null,
        end: day.end ? new Date(day.end) : null,
        compensation: !isNaN(day.compensation) ? day.compensation : null,
        contractWorkLoad: !isNaN(day.contractWorkLoad) ? day.contractWorkLoad : null,
        submitted: day.submitted !== null ? day.submitted : null,
        workEntries: fromWorkEntriesDTO(day.workEntries),
    }
}

export const fromWorkDaysDTO = (workDays) => workDays.map(wd => fromWorkDayDTO(wd))

export const toWorkDayDTO = (day) => {
    return {
        id: day.id ? day.id : null,
        date: DateFormat.formatISOStringWithTimeZone(day.date).split('T')[0],
        start: day.start ? day.start.toISOString() : null,
        end: day.end ? day.end.toISOString() : null,
        compensation: !isNaN(day.compensation) ? day.compensation : null,
        contractWorkLoad: !isNaN(day.contractWorkLoad) ? day.contractWorkLoad : null,
        submitted: day.submitted ? day.submitted : null,
        workEntries: fromWorkEntriesDTO(day.workEntries),
    }
}

export const toWorkDaysDTO = (workDays) => workDays.map(wd => toWorkDayDTO(wd))
